module.exports = __webpack_public_path__ + "static/media/C7F2942E-977B-40F9-97C2-0575A20DEF9B.155edb14.jpeg";